import React, { useEffect, useRef } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Paper
} from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import CustomDatePicker from '../Widgets/CustomDates/CustomDatePicker/CustomDatePicker';

function PaperComponent(props) {
    const nodeRef = useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper ref={nodeRef} {...props} />
        </Draggable>
    );
}

const AddExternalTransactionDialog = ({
    addBankTransactionDialog,
    handleCloseBankAddTransactionDialog,
    newBankEditableItem,
    changeNewBankTransaction,
    handleAddBankTransaction,
    selectedTBank // <-- Add this prop
}) => {
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();

    useEffect(() => {
        if (!newBankEditableItem.transactionDate) {
            changeNewBankTransaction('transactionDate', dayjs());
        }
    }, [addBankTransactionDialog, newBankEditableItem]);

    return (
        <Dialog
            open={addBankTransactionDialog}
            onClose={handleCloseBankAddTransactionDialog}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
        >

            <DialogTitle
                id="draggable-dialog-title"
                sx={{ textAlign: 'center', cursor: 'move' }}
            >
                {t("AddBankCommand")}
            </DialogTitle>
            <DialogContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    textAlign: 'center',
                    minWidth: '300px'
                }}
                className={`${direction}`}
            >
                {/* Description */}
                <div className="form-row-item full-width">
                    <div className="form-row-item-title">
                        {t('Description')}<span className="required-asterisk">*</span>
                    </div>
                    <TextField
                        fullWidth
                        placeholder={t('Description')}
                        value={newBankEditableItem.description || ''}
                        onChange={(e) => changeNewBankTransaction('description', e.target.value)}
                        className="add-client-input-style full-width"
                        variant="standard"
                        InputProps={{
                            disableUnderline: true,
                            className: `custom-input-box-sizing-toggle full-width ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                            sx: {
                                height: '48px',
                                padding: '0 10px',
                                borderRadius: '8px',
                                background: '#F5F5F6',
                                border: '1px solid transparent',
                                '&:focus-within': {
                                    border: '2px solid #304FFF',
                                },
                            },
                        }}
                        inputProps={{
                            style: {
                                width: '100%',
                                textAlign: direction === 'ltr' ? 'left' : 'right',
                            },
                        }}
                        required
                    />
                </div>
                {/* Reference */}
                <div className="form-row-item full-width">
                    <div className="form-row-item-title">
                        {t('Reference')}<span className="required-asterisk">*</span>
                    </div>
                    <TextField
                        fullWidth
                        placeholder={t('Reference')}
                        value={newBankEditableItem.reference || ''}
                        onChange={(e) => changeNewBankTransaction('reference', e.target.value)}
                        className="add-client-input-style full-width"
                        variant="standard"
                        InputProps={{
                            disableUnderline: true,
                            className: `custom-input-box-sizing-toggle full-width ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                            sx: {
                                height: '48px',
                                padding: '0 10px',
                                borderRadius: '8px',
                                background: '#F5F5F6',
                                border: '1px solid transparent',
                                '&:focus-within': {
                                    border: '2px solid #304FFF',
                                },
                            },
                        }}
                        inputProps={{
                            style: {
                                width: '100%',
                                textAlign: direction === 'ltr' ? 'left' : 'right',
                            },
                        }}
                        required
                    />
                </div>
                {/* Transaction Date */}
                <div className="form-row-item full-width">
                    <div className="form-row-item-title">
                        {t('TransactionDate')}<span className="required-asterisk">*</span>
                    </div>
                    <CustomDatePicker
                        date={
                            newBankEditableItem.transactionDate
                                ? newBankEditableItem.transactionDate
                                : null
                        }
                        onDateChange={(date) => {
                            if (date) {
                                changeNewBankTransaction('transactionDate', date);
                            }
                        }}
                        height="48px"
                    />
                 
                </div>
                {/* Amount */}
                <div className="form-row-item full-width">
                    <div className="form-row-item-title">
                        {/* Dynamic label for Amount */}
                        {(selectedTBank?.foreignCurrencyCode != null && selectedTBank?.foreignCurrencyCode !== undefined)
                            ? t('CurrencyAmount')
                            : t('Amount')}
                        <span className="required-asterisk">*</span>
                    </div>
                    <TextField
                        fullWidth
                        placeholder={(selectedTBank?.foreignCurrencyCode != null && selectedTBank?.foreignCurrencyCode !== undefined)
                            ? t('CurrencyAmount')
                            : t('Amount')}
                        value={newBankEditableItem.amount || ''}
                        onChange={(e) => changeNewBankTransaction('amount', e.target.value)}
                        className="add-client-input-style full-width"
                        variant="standard"
                        type="number"
                        InputProps={{
                            disableUnderline: true,
                            className: `custom-input-box-sizing-toggle full-width ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                            sx: {
                                height: '48px',
                                padding: '0 10px',
                                borderRadius: '8px',
                                background: '#F5F5F6',
                                border: '1px solid transparent',
                                '&:focus-within': {
                                    border: '2px solid #304FFF',
                                },
                            },
                        }}
                        inputProps={{
                            style: {
                                width: '100%',
                                textAlign: direction === 'ltr' ? 'left' : 'right',
                            },
                        }}
                        required
                    />
                </div>
            </DialogContent>
            <DialogActions
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    textAlign: 'center',
                }}
            >
                <Button
                    onClick={handleCloseBankAddTransactionDialog}
                    color="primary"
                    variant="contained"
                    sx={{
                        backgroundColor: 'white',
                        color: 'var(--Foundation-Yellow-Normal, var(--orange, #F9AA2A))',
                        padding: '10px 20px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        marginTop: '20px',
                        borderRadius: 'var(--Spacing-md, 8px)',
                        border: '2px solid var(--orange, #F9AA2A)',
                        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                        '&:hover': {
                            transform: 'scale(1.01)',
                        }
                    }}
                >
                    {t("Cancel")}
                </Button>
                <Button
                    onClick={handleAddBankTransaction}
                    color="primary"
                    variant="contained"
                    sx={{
                        backgroundColor: newBankEditableItem.description && newBankEditableItem.reference && newBankEditableItem.transactionDate && newBankEditableItem.amount ? '#304FFF' : '#b0b0b0',
                        color: 'white',
                        padding: '10px 20px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        marginTop: '20px',
                        borderRadius: '8px',
                        border: '1px solid var(--foreground, #000)',
                        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
                        '&:hover': {
                            transform: 'scale(1.01)',
                            backgroundColor: newBankEditableItem.description && newBankEditableItem.reference && newBankEditableItem.transactionDate && newBankEditableItem.amount ? '#1565c0' : '#b0b0b0',
                        },
                    }}
                    disabled={!(newBankEditableItem.description && newBankEditableItem.reference && newBankEditableItem.transactionDate && newBankEditableItem.amount)}
                >
                    {t("Add")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddExternalTransactionDialog;
